import { PracticeSubmissionStatusResult } from '@module/assignment';
import { SuccessTag, ErrorTag } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
export var PracticeSubmissionStatusResultComponent = function PracticeSubmissionStatusResultComponent(_ref) {
  var status = _ref.status;
  var isPassed = status === PracticeSubmissionStatusResult.PASSED;

  if (isPassed) {
    return /*#__PURE__*/_jsx(SuccessTag, {
      children: "Passed "
    });
  }

  return /*#__PURE__*/_jsx(ErrorTag, {
    children: "Failed "
  });
};